import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import classes from "./NewsDetails.module.css";
import FirstNews from "../../../assets/partnersBackground.jpg";

const NewsDetails = () => {
	const newsItems = [
		{
			id: 1,
			title: "The Tech Revolution in Logistics: A Glimpse into the Future",
			description:
				"Commitment to protecting what you hold dear is a testament to the transformative power of insurance.",
			content: "Full content of the news article goes here...",
			image: FirstNews,
		},
		{
			id: "2",
			title: "Another News Title",
			description: "Description for another news item.",
			image: FirstNews,
		},
		{
			id: "3",
			title: "Yet Another News Title",
			description: "Description for yet another news item.",
			image: FirstNews,
		},
	];

	const location = useLocation();
	// Set only when a news card opens this page. This route is also the catch-all `/:title`, so any
	// unknown link lands here with no state; it used to crash the whole app on that.
	const id = (location.state as { id?: number; title?: string } | null)?.id;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	if (id === undefined) return <Navigate to="/main" replace />;

	const notification = newsItems.find((item: any) => item.id === id);

	return (
		<div className={classes.bossContainer}>
			<div
				className={classes.mainContainer}
				style={{
					backgroundImage: `url(${notification?.image})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				<div className={classes.textContainer}>
					{notification && (
						<>
							<h1 className={classes.h1Text}>
								{notification.title}
							</h1>
							<p className={classes.pText}>
								{notification.description}
							</p>
						</>
					)}
				</div>
			</div>
			{/* <NewsDiv /> */}
		</div>
	);
};

export default NewsDetails;
